import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/buttons/Button";
import Content from "../../../components/Content";
import InputField from "../../../components/Inputs/InputField";
import * as serviceApi from "../../../hooks/useServiceData";
import Check from "../../../components/Inputs/Check";
import { useSnackbar } from "notistack";

export const ServiceEditView = () => {
  const navigate = useNavigate();
  const { id: serviceId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [edited, setEdited] = useState(false);

  const [name, setName] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const [cost, setCost] = useState("");
  const [isActive, setIsActive] = useState(true);

  const { data } = serviceApi.GetService(serviceId);
  const { mutate } = serviceApi.UpdateService();

  useEffect(() => {
    if (data?.data) {
      setName(data?.data.name);
      setOwnerId(data?.data.owner_id);
      setCost(data?.data.cost);
      setIsActive(data?.data.isActive === 1 ? true : false);
    }
  }, [data]);

  const updateService = () => {
    let _service = {};

    _service.serviceId = data?.data.id;
    _service.name = name;
    _service.owner_id = ownerId;
    _service.cost = cost;
    _service.isActive = isActive;

    mutate(_service, {
      onSuccess: () => {
        enqueueSnackbar("Tjänst uppdaterad.", {
          variant: "success",
        });
        navigate(`/registry/service/details/${serviceId}`);
      },
      onError: (error) => {
        enqueueSnackbar("Tjänst kunde inte uppdateras.", {
          variant: "error",
        });
        console.log("ERROR UPDATING SERVICE: ", error);
      },
    });
  };

  return (
    <>
      <Content title={`${data?.data.name}`}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            updateService();
          }}
          className="container"
          style={{ width: "100%" }}
        >
          <div className="form-grid-auto">
            <InputField
              required
              label={"Tjänstens namn"}
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setEdited(true);
              }}
            />
            <InputField
              required
              label={"Tjänstens id"}
              value={ownerId}
              onChange={(e) => {
                setOwnerId(e.target.value);
                setEdited(true);
              }}
            />
            <InputField
              required
              type="number"
              label={"Tjänstens kostnad"}
              value={cost}
              onChange={(e) => {
                setCost(e.target.value);
                setEdited(true);
              }}
            />
          </div>

          <Check
            color="success"
            label="Aktiv Tjänst"
            checked={isActive}
            onChange={(e) => {
              setIsActive(e.target.checked);
              setEdited(true);
            }}
          />

          <div className="rightAlign-button-container">
            <Button
              className={edited ? "button-pulse" : undefined}
              disabled={!edited}
              type="submit"
              color="success"
            >
              Spara
            </Button>
          </div>
        </form>
      </Content>
    </>
  );
};
